import { useEffect } from "react";
import { PARCEL_BOOKING_REFRESH_EVENT } from "../types/parcelBookingSignalR.types";
import { NOTIFICATIONS_REFRESH_EVENT } from "../types/notification.types";

/**
 * Re-runs when SignalR booking events or notification refresh fires.
 * @param {() => void} onRefresh
 */
export function useParcelBookingRefresh(onRefresh) {
  useEffect(() => {
    if (typeof onRefresh !== "function") return undefined;

    const handler = () => {
      onRefresh();
    };

    window.addEventListener(PARCEL_BOOKING_REFRESH_EVENT, handler);
    window.addEventListener(NOTIFICATIONS_REFRESH_EVENT, handler);
    return () => {
      window.removeEventListener(PARCEL_BOOKING_REFRESH_EVENT, handler);
      window.removeEventListener(NOTIFICATIONS_REFRESH_EVENT, handler);
    };
  }, [onRefresh]);
}

export default useParcelBookingRefresh;
